import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

export default function CTASection() {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <section ref={ref} className="relative py-24 px-5 overflow-hidden">
      <motion.div
        animate={{
          background: [
            'linear-gradient(135deg, #0a0a0a 0%, #1a1a3e 50%, #0a0a0a 100%)',
            'linear-gradient(135deg, #1a1a3e 0%, #0a0a0a 50%, #1a1a3e 100%)',
            'linear-gradient(135deg, #0a0a0a 0%, #1a1a3e 50%, #0a0a0a 100%)'
          ]
        }}
        transition={{ duration: 15, repeat: Infinity }}
        className="absolute inset-0"
      />

      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.8 }}
        className="relative z-10 text-center max-w-2xl mx-auto"
      >
        <p className="text-[#00d4ff] text-xs tracking-[0.3em] uppercase mb-4">
          FOR MANUFACTURERS
        </p>
        <h2 className="text-white text-4xl font-black mb-6 leading-tight">
          メーカー様へ
        </h2>
        <p className="text-[#cccccc] text-base leading-relaxed mb-10 px-4">
          3DCARS.JPで貴社製品を3D展示しませんか？<br />
          ユーザーとの新しい接点を創出します。<br />
          最新技術で製品の魅力を最大限に伝えましょう。
        </p>

        <motion.a
          href="#contact"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="inline-flex items-center gap-3 px-12 py-4 bg-gradient-to-r from-[#00d4ff] to-[#39ff14] text-black text-lg font-bold rounded-full shadow-[0_0_30px_rgba(0,212,255,0.6)] hover:shadow-[0_0_40px_rgba(0,212,255,0.8)] transition-all cursor-pointer whitespace-nowrap"
        >
          お問い合わせ
          <i className="ri-arrow-right-line text-xl"></i>
        </motion.a>
      </motion.div>
    </section>
  );
}